import {
  recalculateShiftHours,
  recalculateDayHours,
  recalculatePayoutHours,
} from '../../utils/timekeeping/shiftCalculations';
import { useShiftManagement } from './useShiftManagement';

/**
 * Wrapper hook for manager (SuperTimesheet) shift management
 * Uses payout field names (regularTimePayout, startTimePayout, etc.)
 * 
 * @param {Function} setCombinedWeeklyHours - State setter for weekly hours data
 * @returns {Object} - Shift management functions
 */
export const useManagerShiftManagement = (setCombinedWeeklyHours) => {
  return useShiftManagement(setCombinedWeeklyHours, {
    fieldNames: {
      timeStart: 'startTimePayout',
      timeEnd: 'finishTimePayout',
      hoursRegular: 'regularTimePayout',
      hoursOvertime: 'overtimePayout',
      hoursDoubleTime: 'doubleTimePayout',
    },
    recalculateShiftHoursFn: recalculateShiftHours,
    recalculateDayHoursFn: recalculateDayHours,
    recalculateAllHoursFn: recalculatePayoutHours,
    defaultShift: {
      id: null,
      shiftIndex: 0,
      job: null,
      jobPayout: null,
      workScope: null,
      workDescription: null,
      breaksCompleted: true,
      startTime: '07:00',
      finishTime: '15:00',
      startTimePayout: '07:00',
      finishTimePayout: '15:00',
      regularTime: 0,
      overtime: 0,
      doubleTime: 0,
      regularTimePayout: 0,
      overtimePayout: 0,
      doubleTimePayout: 0,
      hoursOverrides: {},
      missingLogs: false,
    },
  });
};
